module.exports = __webpack_public_path__ + "static/media/47.2df4e06.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/47.wav
// module id = DT7f
// module chunks = 0